<template>
  <v-list-item prepend-icon="far fa-dot-circle" :title="$t('sessionReplay.start')" :disabled="sessionReplayStore.isStopping || sessionReplayStore.isSendingDescription" @click="sessionReplayStore.openStartDialog" />
</template>

<script setup lang="ts">
import { useSessionReplayStore } from "@/store/sessionReplay"

const sessionReplayStore = useSessionReplayStore()
</script>
